import { DispatchedEvents } from '@/models/dispatched-events.enum';
import store from '@/store';

class GeotargetingPresenter {

	public updateStoreWhenGeotargetingMicroserviceIsReady(): void {
		document.addEventListener(
			DispatchedEvents.GEOTARGETING_MICROSERVICE_LOADED,
			store.mutations.markGeotargetingMicroserviceAsReady.bind(store.mutations)
		);
	}
}

export default new GeotargetingPresenter();
